export default __webpack_public_path__ + "static/media/irecharge.49d81e39.png";